var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"app-container",class:{ 'app-mobile': _vm.isDevice, 'app-mobile-dark': _vm.theme === 'dark' }},[_c('chat-container',{attrs:{"theme":_vm.theme,"is-device":_vm.isDevice},on:{"show-demo-options":function($event){_vm.showDemoOptions = $event}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }